var router = require('pjax').Router;

var index = require('./index.js');
var integration = require('./integration.js');

router.get('integration', index);
router.get('integration/:any', integration);
